module.exports = __webpack_public_path__ + "img/poland-logo-icon.916632a6.png";